import AppBase from "../layouts/AppBase.jsx";
import SignIn from "../pages/auth/SignIn";
import AppStatus from "../pages/i4/AppStatus";
import TelaCheia from "../layouts/TelaCheia";

// { path: "/pages", name: "Pages", component: Pages },
// { path: "/components", name: "Components" , component: Components },

var indexRoutes = [

    { path: "/login", name: "login", component: SignIn },
    { path: "/status", name: "", icon: "assignment", component: AppStatus , type : "noRoot", routeParam: "exact", secgroup: 2 },
    { path: "/pc", name: "", icon: "assignment", component: TelaCheia , secgroup: 2 },
    { path: "/", name: "Aplicacao Principal", component: AppBase },



];

export default indexRoutes;
//
